// extracted by mini-css-extract-plugin
export var checkboxInputRow = "n_qy";
export var checkboxInputColumn = "n_qz";
export var inputOptionRow = "n_qq";
export var inputOptionColumn = "n_qr";